import { render, staticRenderFns } from "./defaultHeader.vue?vue&type=template&id=90624f6e&"
import script from "./defaultHeader.vue?vue&type=script&lang=js&"
export * from "./defaultHeader.vue?vue&type=script&lang=js&"
import style0 from "./defaultHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports